import { forwardRef, memo, type PropsWithChildren } from 'react';

import { DATA_ATTR_CONTENT_TYPE } from '../../constants.ts';
import { useTableContext } from '../../context.tsx';
import { CellInner, CellTitle, CellWrapper } from './styled.ts';
import type { CellProps } from './types.ts';

export const Cell = memo(
  forwardRef<HTMLDivElement, PropsWithChildren<CellProps>>(function Cell(
    { children, className, title, align, mobileVerticalAlign, textBold, contentType, fullRow, colSpan, noWrap, breakWord, dataTestId },
    ref,
  ) {
    const { compact } = useTableContext();

    return (
      <CellWrapper
        className={className}
        $align={align}
        $mobileVerticalAlign={mobileVerticalAlign}
        $textBold={textBold}
        $contentType={contentType}
        $fullRow={fullRow}
        $colSpan={colSpan}
        $compact={compact}
        $noWrap={noWrap}
        $breakWord={breakWord}
        ref={ref}
        role='cell'
        {...{ [DATA_ATTR_CONTENT_TYPE]: contentType }}>
        {title && <CellTitle>{title}</CellTitle>}
        <CellInner $contentType={contentType} data-testid={dataTestId}>
          {children}
        </CellInner>
      </CellWrapper>
    );
  }),
);
